import { ApolloLink, Observable } from '@apollo/client/core';

import { AuthService } from './services/auth.service';

/**
 * Delays each GraphQL operation until the access JWT is fresh when a refresh token exists.
 * The API often returns HTTP 200 with field-level "not authorized" for an expired Bearer, so
 * {@link AuthInterceptor} never sees HTTP 401 and cannot refresh otherwise.
 */
export function createGraphqlAuthRefreshLink(authService: AuthService): ApolloLink {
  return new ApolloLink((operation, forward) =>
    new Observable((observer) => {
      const subscription = authService.ensureAccessTokenFreshBeforeGraphql$().subscribe({
        next: () => {
          forward(operation).subscribe({
            next: (value) => observer.next(value),
            error: (error) => observer.error(error),
            complete: () => observer.complete(),
          });
        },
        error: (error) => observer.error(error),
      });

      return () => subscription.unsubscribe();
    }),
  );
}
